module.exports = __webpack_public_path__ + "static/hlt-corp-02-5c34c5b7d7c9c5619e9f843aeed774d2.jpg";